import FileSaver from 'file-saver'; 
import { saveDocument } from './savePTODoc';
import { document } from '~/api';

export const generatePXTFile = async (allData = {}, titleOpinionId = 0, isPrintOnly = true) => {
    
    try {
        let pxtTextArr = await extractPXTData(allData);
    
        var blob = new Blob(pxtTextArr, {type: "text/plain;charset=utf-8"});
        FileSaver.saveAs(blob, 'PXT File.pxt');

        if(!isPrintOnly) {
            //save
            let blobToFile = blob;
            blobToFile.lastModifiedDate = new Date();
            blobToFile.name = 'PXT File.pxt';
            let description = 'PXT File';
            
            let _file = {
                file: blobToFile,
                uploadLink: {},
                uploadInfo: {},
                isDeleted: false,
                type: document.DocumentType.PXT_FILE,
                uploaded: false
            };
            return saveDocument(_file, description, titleOpinionId, document.DocumentType.PXT_FILE);
        }
    }
    catch(err) {
        console.error(err);
    }
};

async function extractPXTData(allData = {}) {
    const { 
        propertyInfoData,
        titleInsuraceApplicationData,
        additionalInformationData
    } = allData;

    const propertySectionData = Object.prototype.hasOwnProperty.call(propertyInfoData.section, '_data') ? JSON.parse(propertyInfoData.section._data) : {};
    const propertySectionDetailsData =  Array.isArray(propertyInfoData.sectionDetails) ? propertyInfoData.sectionDetails.filter(x => x.sectionId == propertyInfoData.section.sectionId)[0]?._data : {};
    const titleInsuraceApplicationSectionData = Object.prototype.hasOwnProperty.call(titleInsuraceApplicationData.section, '_data') ? JSON.parse(titleInsuraceApplicationData.section._data) : {};
    const titleInsuraceAppSectionDetails_Insured = Array.isArray(titleInsuraceApplicationData.sectionDetails) ? titleInsuraceApplicationData.sectionDetails.filter(x => x.sectionId == titleInsuraceApplicationData.section.sectionId && x._data.type == 'insured')[0]?._data : {};
    const titleInsuraceAppSectionDetails_lenderPrimary = Array.isArray(titleInsuraceApplicationData.sectionDetails) ? titleInsuraceApplicationData.sectionDetails.filter(x => x.sectionId == titleInsuraceApplicationData.section.sectionId && x._data.type == 'lenderPrimary')[0]?._data : {};
    const additionalInformationSectionData = Object.prototype.hasOwnProperty.call(additionalInformationData.section, '_data') ? JSON.parse(additionalInformationData.section._data) : {};
    //console.log('generatePXTFile...' + JSON.stringify(titleInsuraceApplicationData));

    let settdate = isValidDate(new Date(propertySectionData?.estimatedClosingDate)) ? String(new Date(propertySectionData?.estimatedClosingDate).toLocaleDateString()) : '';
    let searchPeriodEndDate = isValidDate(new Date(additionalInformationSectionData?.throughSearchPeriod)) ? String(new Date(additionalInformationSectionData?.throughSearchPeriod).toLocaleDateString()) : '';
    let firstCurrentOwnerName = propertySectionDetailsData?.ownerPrimary?.ownerFirstName == undefined ? '' : propertySectionDetailsData?.ownerPrimary?.ownerFirstName;
    let lastCurrentOwnerName = propertySectionDetailsData?.ownerPrimary?.ownerLastName == undefined ? '' : propertySectionDetailsData?.ownerPrimary?.ownerLastName;
    let firstCurrentOwnerNames = firstCurrentOwnerName + ' ' + lastCurrentOwnerName; 
    firstCurrentOwnerNames = firstCurrentOwnerNames === undefined || firstCurrentOwnerNames === null ? '' : firstCurrentOwnerNames;
    let secondCurrentOwnerNames = propertySectionDetailsData?.ownerSecondary?.ownerFirstName + ' ' + propertySectionDetailsData?.ownerSecondary?.ownerLastName; 
    secondCurrentOwnerNames = secondCurrentOwnerNames === undefined || secondCurrentOwnerNames === null ? '' : secondCurrentOwnerNames;
    let firstInsuredName = titleInsuraceAppSectionDetails_Insured?.insuredPrimary?.insuredFirstName === undefined ? '' : titleInsuraceAppSectionDetails_Insured?.insuredPrimary?.insuredFirstName;
    let lastNameInsured = titleInsuraceAppSectionDetails_Insured?.insuredPrimary?.insuredLastName === undefined ? '' : titleInsuraceAppSectionDetails_Insured?.insuredPrimary?.insuredLastName;
    let firstInsuredNames = firstInsuredName + ' ' + lastNameInsured;
    firstInsuredNames = firstInsuredNames === undefined || firstInsuredNames === null ? '' : firstInsuredNames;
    let secondInsuredNames = titleInsuraceAppSectionDetails_Insured?.insuredSecondary?.insuredFirstName + ' ' + titleInsuraceAppSectionDetails_Insured?.insuredSecondary?.insuredLastName;
    secondInsuredNames = secondInsuredNames === undefined || secondInsuredNames === null ? '' : secondInsuredNames;
    let insuredRelationship = titleInsuraceAppSectionDetails_Insured?.relationship?.label;
    let same_as_owner = titleInsuraceApplicationSectionData?.sameAsOwner === undefined ? false: titleInsuraceApplicationSectionData?.sameAsOwner;
    let loan_type = titleInsuraceApplicationSectionData?.loanTypePrimary?.label;
    loan_type = loan_type == 'Conventional' ? 'Conv. Unins.' : loan_type;
    
    let pxtData = {
        transactionType: 'PURCREFI=' + propertySectionData?.transactionType?.label,
        closingDate: 'SETTDATE=' + settdate,
        useOfProperty: 'PROPUSE=' + propertySectionData?.useOfProperty?.label,
        firstCurrentOwnerNames: 'SLR1NAM1=' + firstCurrentOwnerNames,
        currentOwnerRelationship: 'SLR1REL1=' + propertySectionDetailsData?.relationship?.label,
        secondCurrentOwnerNames: 'SLR1NAM2=' + secondCurrentOwnerNames,
        propertyStreetAddress: 'PROPSTRE=' + propertySectionData?.street,
        propertyCity: 'PROPCITY=' + propertySectionData?.city,
        propertyStateLetters: 'STATELET=' + propertySectionData?.state?.value,
        propertyZip: 'PROPZIP=' + propertySectionData?.zipcode,
        propertyCounty: 'COUNTY=' + propertySectionData?.county,
        legalDescription: 'PROPDES=' + propertySectionData?.notes,
        searchPeriodEndDate: 'CTEFFDATE=' + searchPeriodEndDate,
        ownersInsuranceCoverageAmount: 'SALEPRICE=' + String(titleInsuraceApplicationSectionData?.ownerInsuranceCoverageAmount),
        firstInsuredNames: 'BYR1NAM1=' + String(same_as_owner ? firstCurrentOwnerNames : firstInsuredNames),
        insuredRelationship: 'BYR1REL1=' + String(same_as_owner ? propertySectionDetailsData?.relationship?.label : insuredRelationship),
        secondInsuredNames: 'BYR1NAM2=' + String(same_as_owner ? secondCurrentOwnerNames : secondInsuredNames),
        lendersInsuranceCoverageAmount: 'LOANAMT=' + String(titleInsuraceApplicationSectionData?.lenderInsuranceCoverageAmount),
        lendersName: 'LENNAM1=' + titleInsuraceAppSectionDetails_lenderPrimary?.lenderDetailData?.lenderName,
        lendersStreetAddress: 'LENADR1=' + titleInsuraceAppSectionDetails_lenderPrimary?.lenderDetailData?.lenderStreetAddress,
        lenderCity: 'LENADR2=' + titleInsuraceAppSectionDetails_lenderPrimary?.lenderDetailData?.lenderCity,
        lenderState: 'LENADR2=' + titleInsuraceAppSectionDetails_lenderPrimary?.lenderDetailData?.lenderState,
        lenderZip: 'LENADR2=' + titleInsuraceAppSectionDetails_lenderPrimary?.lenderDetailData?.lenderZip,
        loanType: 'LOANTYPE=' + loan_type,
        loanNumber: 'LOANNUMB=' + titleInsuraceApplicationSectionData?.loanNumberPrimary
    };

    let pxtTextArr = [];

    for (const p in pxtData) {
        let data = pxtData[p].replace(/undefined/g, '');
        pxtTextArr.push(data + ' \r\n');
    }

    return pxtTextArr;
}

function isValidDate(date) {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}